import React from 'react'
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import AttendanceForm from './attendanceForm';
import { useState } from 'react';
import { useEffect } from 'react';
import { attendanceApi, Util } from '../../services';
import { Calendar } from 'primereact/calendar';
import { useFormik } from "formik";
import { toast } from "react-toastify";
import { confirmDialog } from "primereact/confirmdialog";
import { Button } from "primereact/button";

export default function MissingAttendance() {
  const [missingAttendanceList, setMissingAttendanceList] = useState([]);
  useEffect(() => {
    fetchMissingAttendance();
  }, []);

  const fetchMissingAttendance = () => {
    attendanceApi.getAttendanceRequests().then((resp) => {
      try {
        const sortedData = resp.data.data.sort((a, b) => new Date(b.date) - new Date(a.date));
        setMissingAttendanceList(sortedData);
      } catch (error) {
        // Error handle
      }
    });
  }
  const closeAttendanceForm = () => {
    fetchMissingAttendance();
  }
  const formik = useFormik({
    initialValues: {
      inTime: '',
      outTime: '',
      date: null,
      reason: null,
    },
  });

  const fetchStatus = (status) => {
    if (status === 3) return (<div style={{ color: "rgb(222 204 90)" }}>PENDING FOR APPROVAL</div>);
    if (status === 4) return (<div style={{ color: "red" }}>REJECTED</div>);
  };

  const statusBodyTemplate = (data) => {
    return (
      <span style={{ borderRadius: "8px", fontSize: "12px", fontWeight: "700" }}>{fetchStatus(data.status)}</span>
    );
  }
  const reviewActionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button icon="pi pi-trash" className="p-button-rounded p-button-danger mr-2" tooltip="Delete Attendance" tooltipOptions={{ position: "top" }} onClick={(e) => deleteCompleteAttendance(e, rowData)} />
      </React.Fragment>

    )
  }

  const deleteCompleteAttendance = (e, rowData) => {
    confirmDialog({
      target: e.currentTarget,
      message: 'Are you sure you want to delete this attendance?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      acceptClassName: "p-button-danger",
      acceptLabel: 'No',
      rejectLabel: 'Yes',
      reject: () => {
        let param = {
          Ids: [rowData.id],
        };
        try {
          attendanceApi.deletemutipleAttendance(param).then((resp) => {
            toast.success("Record deleted successfully");
            fetchMissingAttendance();
          })
        } catch (error) {

        }
      },
      accept: () => { }
    });
  }

  return (
    <React.Fragment>
      <div className='grid'>
        <div className='col-6'>
          <h1 style={{margin: 0}}>Missing Attendance</h1>
        </div>
        <div className='col-6 flex flex-wrap justify-content-end'>
          <AttendanceForm onCloseForm={closeAttendanceForm}></AttendanceForm>
        </div>
      </div>
      <DataTable
        value={missingAttendanceList}
        tableStyle={{ minWidth: "50rem" }}
        paginator
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
        editMode="row"
        rows={10}
        rowsPerPageOptions={[10, 20, 50]}
        dataKey="id"
      >
        <Column field="date" style={{ minWidth: "8rem" }} header="Date"></Column>
        <Column field="outDate" style={{ minWidth: "8rem" }} header="Out Date"></Column>
        <Column field="location" style={{ minWidth: "8rem" }} header="Location"></Column>
        <Column field="inTime" style={{ minWidth: "8rem" }} body={Util.inTimeTemplate} header="In Time"></Column>
        <Column field="outTime" style={{ minWidth: "8rem" }} body={Util.outTimeTemplate} header="Out Time" ></Column>
        <Column field="" body={Util.workingHoursDff} header="Total Time"></Column>
        <Column field="rejectReason" style={{ minWidth: "8rem" }} header="Reject Reason" ></Column>
        <Column field="status" header="Status" body={statusBodyTemplate}></Column>
        <Column field="" header="Action" body={reviewActionBodyTemplate} ></Column>
      </DataTable>
    </React.Fragment>
  )
}